import React, { useEffect, useState } from 'react';
import aboutimg1 from '../../images/aboutpage/aboutimg3.png';
import aboutimg2 from '../../images/aboutpage/aboutimg.png';
import aboutimg3 from '../../images/aboutpage/aboutimg4.png';
import "./service.css";
import Quatationform from "../formdesign/quoteform";
import aw1 from '../../images/awandwin/aw1.png';
import aw2 from '../../images/awandwin/aw2.png';
import { BiRightArrowAlt } from "react-icons/bi";
import hsimg1 from '../../images/herobanner2.png';
import hsimg2 from '../../images/package2.png';
import hsimg3 from '../../images/pakage1.png';
import serviabt1 from '../../images/service/serviceabt.png';
import port1 from '../../images/service/port1.png';
import port2 from '../../images/service/port2.png';
import port3 from '../../images/service/port3.png';
import port4 from '../../images/service/port4.png';
import port6 from '../../images/service/port6.png';
import port7 from '../../images/service/port7.png';
import port8 from '../../images/service/port8.png';
import port5 from '../../images/service/port5.png';
import success1 from "../../images/success/success (1).png";
import success2 from "../../images/success/success (2).png";
import success3 from "../../images/success/success (3).png";
import success4 from "../../images/success/success (4).png";
import abimg1 from "../../images/c1 (1).png";
import abimg2 from "../../images/c1 (2).png";
import abimg3 from "../../images/c1 (3).png";
import abimg4 from "../../images/c1 (4).png";
import Accordion from '../Home/accordian/Accordion';
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import Testimonial from "../Home/powerfull/powerfull";
import Popup from '../pup/popup';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

export default function Homeinterior() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [aboutimg1, aboutimg2, aboutimg3];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  const portfolioimg1 = [port1, port2, port3, port4];
  const duplicatedImages = [...portfolioimg1, ...portfolioimg1];
  const portfolioimg2 = [port5, port6, port7, port8];
  const duplicatedImages2 = [...portfolioimg2, ...portfolioimg2];

  const items = [
    {
      title: 'What home interior services does Cedar Interiors provide in Kerala?',
      content: 'At Cedar Interiors, we specialize in creating personalized living spaces, including modular kitchens, bedroom interiors, dining rooms, and living room designs, tailored to your needs in Cochin, Palakkad, Tiruvalla, and other parts of Kerala.',
    },
    {
      title: 'How long does it take to complete a home interior project?',
      content: 'Our typical project timeline is 45 days, depending on the scope and complexity of the design. We pride ourselves on delivering exceptional interiors on time.',
    },
    {
      title: 'What materials do you use for home interiors?',
      content: 'We use premium, eco-friendly materials sourced from trusted suppliers to ensure durability and elegance in every project we deliver.',
    },
    {
      title: 'Can I customize my home interior design with Cedar Interiors?',
      content: 'Absolutely! We focus on bespoke designs, allowing you to personalize every detail to suit your style and functional requirements.'
    },
    {
      title: 'Do you offer after-sales support for home interiors?',
      content: 'Yes, we provide dedicated after-sales support to address any concerns and ensure your home remains beautiful and functional for years to come.Let me know if you’d like further adjustments!'
    },
  ];

  const detailedFaqs = [
    {
      title: '1. Where do we start with interior design?',
      content: 'We begin with an initial consultation to understand your lifestyle, requirements, preferences, budget, and timeline. This helps us create a design plan that reflects your vision and practical needs.',
    },
    {
      title: '2. What is your interior design process?',
      content: (
        <div>
          <p>Our process typically includes:</p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>Initial consultation</li>
            <li>Space planning and concept development</li>
            <li>Design presentation (layouts, materials, 3D visuals if required)</li>
            <li>Budget finalization</li>
            <li>Execution and site coordination</li>
            <li>Final styling and handover</li>
          </ul>
        </div>
      ),
    },
    {
      title: '3. How long does the interior design project take?',
      content: 'Project timelines vary based on the scope of work, size of the space, and material availability. On average, a full home interior project may take 6–16 weeks after design approval.',
    },
    {
      title: '4. Do I need to move out during the renovation?',
      content: 'This depends on the scale of work. For minor upgrades, you may continue living in the home. For major renovations, temporary relocation may be more comfortable.',
    },
    {
      title: '5. Can the project be done in phases?',
      content: 'Yes. We can plan and execute the project in phases to suit your budget, convenience, or timelines.',
    },
    {
      title: '6. How much does interior design cost?',
      content: 'Costs depend on the size of the space, design complexity, materials, and customization. We provide a transparent estimate after understanding your requirements.',
    },
    {
      title: '7. What is included in your design fee?',
      content: 'Our design fee generally includes space planning, concept development, design drawings, material selection, and project coordination. The exact inclusions will be clearly outlined in our agreement.',
    },
    {
      title: '8. Can you work within a fixed budget?',
      content: 'Absolutely. We design solutions that align with your budget while maintaining quality, functionality, and aesthetics.',
    },
    {
      title: '9. Are there any additional or hidden costs?',
      content: 'We aim for complete transparency. Any additional costs due to changes in scope, material upgrades, or unforeseen site conditions will be discussed and approved before proceeding.',
    },
    {
      title: '10. How do you help me choose the right design style?',
      content: 'We guide you through styles, references, and mood boards while considering your taste, lifestyle, and the architecture of your home.',
    },
    {
      title: '11. Can you use my existing furniture or décor?',
      content: 'Yes. We can incorporate your existing furniture and décor wherever possible to create a cohesive and cost-effective design.',
    },
    {
      title: '12. Will I see the design before execution?',
      content: 'Yes. We present detailed layouts, material samples, and 3D visualizations (if included) so you can clearly visualize the final outcome.',
    },
    {
      title: '13. How do you ensure functionality along with aesthetics?',
      content: 'Our designs focus on space planning, ergonomics, storage solutions, lighting, and daily usability—ensuring your home looks beautiful and works efficiently.',
    },
    {
      title: '14. What materials and brands do you use?',
      content: 'We work with trusted vendors and high-quality materials. Material options are selected based on durability, budget, and maintenance requirements.',
    },
    {
      title: '15. Do you offer custom furniture and storage solutions?',
      content: 'Yes. We design and execute customized furniture and storage tailored specifically to your space and needs.',
    },
    {
      title: '16. Can you make small spaces look bigger?',
      content: 'Yes. Through smart layouts, light colors, mirrors, proper lighting, and multifunctional furniture, we maximize both space and comfort.',
    },
    {
      title: '17. Who manages contractors and vendors?',
      content: 'We coordinate with contractors, carpenters, electricians, and vendors to ensure smooth execution and quality control.',
    },
    {
      title: '18. How often will I receive project updates?',
      content: 'We provide regular updates through site visits, calls, or messages so you are informed at every stage of the project.',
    },
    {
      title: '19. What happens if I want to make changes during execution?',
      content: 'Design changes can be accommodated depending on the project stage. Any impact on cost or timeline will be discussed before implementation.',
    },
    {
      title: '20. Do you offer post-completion support?',
      content: 'Yes. We provide post-installation support and assist with warranty-related issues where applicable.',
    },
    {
      title: '21. How easy will it be to maintain the interiors?',
      content: 'We select materials and finishes that balance beauty with ease of maintenance and long-term durability.',
    },
    {
      title: '22. Why should I hire an interior designer?',
      content: 'Hiring a professional interior designer saves time, avoids costly mistakes, optimizes space, and ensures a cohesive, functional, and aesthetically pleasing result.',
    },
  ];

  const [showPopup, setShowPopup] = useState(false); // State to control popup visibility

  const openPopup = () => {
    setShowPopup(true); // Function to open the popup
  };

  const closePopup = () => {
    setShowPopup(false); // Function to close the popup
  };

  return (
    <>
      <Helmet>
        <title>Home Interior Designers in Palakkad | Interior Decorator</title>
        <meta name="description" content="Cedar Interiors, trusted home interior designers in Palakkad, dedicated to creating elegant, functional living spaces that reflect your lifestyle." />
      </Helmet>
      <div className="service-main">
        <div className="servicehero"></div>
        <div className="servicehero1">
          <div className="servicehero1col">
            <div className="discount">
              <h2 className="header2">
                <span> Best Home Interior Designers in Palakkad</span>
              </h2>
              <h5 className="smallhead">Starting from <span>2 Lakhs</span></h5>
            </div>
          </div>
          <div className="servicehero1col">
            <Quatationform />
          </div>
        </div>
        <div className="serviceinterior">
          <div className="serviceinteriorcol sercol1">
            <div className="service-slide">
              {" "}
              <div className='aboutslider'>
                <div className="about-slider-inner">
                  {images.map((src, index) => (
                    <div
                      key={index}
                      className={`h-slide ${index === currentIndex ? 'active' : ''} ${index === (currentIndex - 1 + images.length) % images.length ? 'previous' : ''}`}
                    >
                      <img src={src} alt={`Slide ${index}`} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="serviceinteriorcol sercol2">
            <div className='awardandwinnig'> <h2 className='header2'><span>Transform Your Home</span></h2>
              <h6>with Premium Interior Designs</h6>
              <p>Experience the perfect blend of style and functionality with Cedar Interiors. Our dedicated team of experts works closely with you to design homes that reflect your personality and meet your lifestyle needs. From contemporary aesthetics to timeless classics, we bring your vision to life with precision and care.</p>
              <p>At Cedar Interiors, we believe that every home tells a story. We are committed to crafting interiors that are not only beautiful but also practical and durable. With a focus on quality craftsmanship and innovative design, we transform spaces into homes you’ll love forever.</p>

              <div className="awardwiningblurb">
                <div className="blurb">
                  <div className='aw-blurbimg'>
                    <img src={aw2} alt="aw" />
                  </div>
                  <div className="aw-blurbcontent">
                    <h5>Premium Quality</h5>
                    <p>Finest materials ensured.</p>
                  </div>
                </div>
                <div className="blurb">
                  <div className='aw-blurbimg'>
                    <img src={aw1} alt="aw" />
                  </div>
                  <div className="aw-blurbcontent">
                    <h5>Innovation
                    </h5>
                    <p>Creative, modern solutions.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hrline-bg">
          <div className="hrline"></div>{" "}
        </div>
        <div className='homeservice'><h2 className="header2">Best Home Interior <span>Designers in Palakkad</span></h2>
          <p className='service-desc'>When it comes to creating beautiful, functional, and personalized living spaces, choosing the best home interior designers in Palakkad can make all the difference. A professional interior design team understands the unique lifestyle, climate, and architectural styles of Palakkad homes, blending aesthetics with practicality to deliver timeless interiors. From modern apartments and luxury villas to traditional homes, expert interior designers in Palakkad offer end-to-end solutions including space planning, modular kitchens, custom furniture, lighting design, material selection, and complete project execution. With a strong focus on quality craftsmanship, innovative design ideas, and transparent pricing, the best interior designers ensure every detail reflects the client’s taste and daily needs. By using premium materials, smart storage solutions, and well-planned layouts, they maximize space while enhancing comfort and elegance. Whether you prefer a contemporary, minimalist, traditional, or luxury interior style, experienced home interior designers in Palakkad work closely with you to transform your vision into reality—delivering homes that are not only visually stunning but also functional, durable, and easy to maintain. Their commitment to timely delivery, personalized service, and after-completion support makes them a trusted choice for homeowners looking to elevate their interiors with confidence</p>
          <div className="hr"></div>
          {/*servicecard*/}
          <div className="homeservicecard">
            <div className="homesercardcol">
              <h5 className="smallhead">Living Room Interiors</h5>
              <img src={hsimg1} alt="homedesign" />
              <p>Transform your living room into the heart of your home with custom-crafted solutions. Whether it’s sleek TV units, practical coffee tables, or artistic partitions, our designs blend functionality and aesthetics to create a space you’ll love.</p>
              <Link to="/living-room-interiors"><button className='btn1'>Learn More<span><BiRightArrowAlt /></span></button></Link>
            </div>
            {/*card2*/}
            <div className="homesercardcol">
              <h5 className="smallhead">Modular Kitchen Designs</h5>
              <img src={hsimg2} alt="homedesign" />
              <p>Upgrade your cooking space with state-of-the-art modular kitchens. From space-efficient L-shaped and straight kitchens to spacious U-shaped and island designs, we offer layouts that seamlessly blend modernity and convenience. Crafted to enhance your cooking experience and add elegance to your home.</p>
              <Link to="/modular-kitchens"><button className='btn1'>Learn More<span><BiRightArrowAlt /></span></button></Link>
            </div>
            {/*card32*/}
            <div className="homesercardcol">
              <h5 className="smallhead">Bedroom Interiors</h5>
              <img src={hsimg2} alt="homedesign" />
              <p>Create a personal sanctuary with customized bedroom interiors. Our solutions include stylish wardrobes, cozy beds, and functional dressing units that combine storage, comfort, and elegance. Experience interiors that bring harmony and rejuvenation to your private space.</p>
              <Link to="/bedroom-interiors"><button className='btn1'>Learn More<span><BiRightArrowAlt /></span></button></Link>
            </div>
            {/*card32*/}
            <div className="homesercardcol">
              <h5 className="smallhead">Dining Room Interiors</h5>
              <img src={hsimg3} alt="homedesign" />
              <p>Reimagine your dining space with thoughtfully designed furniture and layouts. From luxurious dining table sets to smart storage units and room partitions, our designs cater to both family gatherings and formal dinners. A blend of sophistication and practicality for your dining area.</p>
              <Link to="/dining-room-interiors"><button className='btn1'>Learn More<span><BiRightArrowAlt /></span></button></Link>
            </div>

          </div>


        </div>
        <div className='serviceabt'>
          <div className="serviceabtinner">
            <div className="serviceabitinnercol1">
              <div className="servblurb">
                <h3>4 Lakh+ Sq. Ft.</h3>
                <p>Projects Successfully Completed</p>
              </div>
              <div className="servblurb">
                <h3>10-Year</h3>
                <p>Trusted Warranty Coverage</p>
              </div>
              <div className="servblurb1">
                <h3 className='smallhead'>Turning Ideas Into Reality</h3>
                <p>Cedar Interiors transforms ordinary spaces into extraordinary experiences with over two decades of expertise. We craft interiors that blend functionality and aesthetics to bring your dream space to life.</p>
                <button className='btn2' onClick={openPopup}>Get a Quote <span><BiRightArrowAlt /></span></button>
              </div>
            </div>
            <div className="serviceabitinnercol">
              <h2 className="header2">Transform Spaces Into Homes</h2>
              <h6 className="smallhead">with cedar interiors</h6>
              <div className="row1">
                <div className="row1col">
                  <p>Experience bespoke home interiors crafted to reflect your style and needs. Cedar Interiors combines functionality and beauty, ensuring every corner of your home resonates with perfection.
                    Your space, our dedication a partnership that transforms imagination reality.</p>
                </div>
              </div>
              <img src={serviabt1} alt="" />
            </div>
          </div>
        </div>
        <div className='serviceportfolio'>
          <h2 className="header2">Portfolio For <span>Home Interiors</span></h2>
          <p>Discover our curated portfolio of home interiors designed for comfort and style.</p>
          <div className="hr"></div>

          <div className="servportfolioinner">
            <div className="carousel-container">
              <div className="logo-carousel">
                {duplicatedImages.map((logo, index) => (
                  <div key={index} className="logo-item">
                    <img src={logo} alt={`logo-${index}`} />
                  </div>
                ))}
              </div>
            </div>
            {/*second*/}
            <div className="carousel-container">
              <div className="logo-carousel1">
                {duplicatedImages2.map((logo, index) => (
                  <div key={index} className="logo-item">
                    <img src={logo} alt={`logo-${index}`} />
                  </div>
                ))}
              </div>
            </div>

          </div>

        </div>

        <div className="successstory">
          <div className="success">
            <p className="build-success">The Path to Your Perfect Space</p>
            <h2 className="header2">Our Success Route</h2>
            <p className="sucees-elevate">
              Elevate your spaces with Vedar Designs & Interior Fitouts L.L.C.
              Experience the fusion of your aspirations with our expertise, creating
              interiors that speak volumes. Your space, our dedication.
            </p>
          </div>

          <div className="success-card">
            <div className="sucess-card1">
              <ul class="card-color">
                <li class="item">
                  {" "}
                  <img src={success1} alt="" />
                </li>
                <li class="item">
                  {" "}
                  <img src={success2} alt="" />
                </li>
                <li class="item">
                  {" "}
                  <img src={success3} alt="" />
                </li>
                <li class="item">
                  {" "}
                  <img src={success4} alt="" />
                </li>
              </ul>
            </div>
            <div className="success-card2">
              <div className="success-col">
                <div className="blurb">
                  <h4>Inspiration
                  </h4>
                  <p>
                    We start by drawing inspiration from your vision and lifestyle, ensuring every detail reflects your unique taste.
                  </p>
                </div>
              </div>
              <div className="success-col">
                <div className="blurb">
                  <h4>Planning</h4>
                  <p>
                    Strategizing and mapping out the perfect balance of form and function to bring your ideas to life.
                  </p>
                </div>
              </div>
              <div className="success-col">
                <div className="blurb">
                  <h4>Craftsmanship</h4>
                  <p>
                    Bringing designs to reality through innovative techniques and skilled artistry for flawless interiors.
                  </p>
                </div>
              </div>
              <div className="success-col">
                <div className="blurb">
                  <h4>Delivery</h4>
                  <p>
                    Completing your dream space with precision, on-time execution, and uncompromised quality.
                  </p>
                </div>
              </div>
            </div>

            {/* mobile*/}

            <div className="success-card-mob">
              <div class="item">
                {" "}
                <img src={success1} alt="" />
                <div className="blurb">
                  <h4>INSPIRATION</h4>
                  <p>
                    We start by drawing inspiration from your vision and lifestyle, ensuring every detail reflects your unique taste.
                  </p>
                </div>
              </div>



              <div class="item">
                {" "}
                <img src={success2} alt="" />
                <div className="blurb">
                  <h4>PLANNING</h4>
                  <p>
                    Strategizing and mapping out the perfect balance of form and function to bring your ideas to life.
                  </p>
                </div>
              </div>

              <div class="item">
                {" "}
                <img src={success3} alt="" />
                <div className="blurb">
                  <h4>CRAFTSMANSHIP</h4>
                  <p>
                    Bringing designs to reality through innovative techniques and skilled artistry for flawless interiors.
                  </p>
                </div>
              </div>

              <div class="item">
                {" "}
                <img src={success4} alt="" />
                <div className="blurb">
                  <h4>DELIVERY</h4>
                  <p>
                    Completing your dream space with precision, on-time execution, and uncompromised quality.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="aboutchoose">
          <div className="aboutchoosrow1">
            <div className="aboutchooserow1col col1">
              <h2 className="header2">Cedar Assurance</h2>
              <p>
                Cedar Assurance is our promise to make your interior journey seamless and stress-free. We go beyond delivering beautiful spaces by ensuring every detail reflects quality, precision, and care. With our unwavering commitment to innovation and client satisfaction, Cedar Interiors stands as your trusted partner in creating timeless spaces that inspire.
              </p>
            </div>
            <div className="aboutchooserow1col col2">
              <div className="yofexp">
                <p>45</p>
                <span>Days</span>
                <span>Delivery</span>
              </div>

              <div className="yofexp">
                <p>4Lakh</p>
                <span>SqFt</span>
                <span>Developed</span>
              </div>
              <div className="yofexp">
                <p>10</p>
                <span>Years</span>
                <span>Warranty</span>
              </div>
            </div>
          </div>

          <div className="about-card">
            <div className="about1-col">
              <div className="blurb">
                <img src={abimg1} alt="" />
                <h4>45 Days Delivery</h4>
                <p>
                  Enjoy fast and reliable interior solutions for your new home with our guaranteed 45-day delivery. Your dream home, delivered on time.
                </p>
              </div>
            </div>
            <div className="about1-col">
              <div className="blurb">
                <img src={abimg2} alt="" />
                <h4>Design Experts</h4>
                <p>
                  Collaborate with our skilled designers to explore premium ideas and co-create interiors that match your unique style and vision.
                </p>
              </div>
            </div>
            <div className="about1-col">
              <div className="blurb">
                <img src={abimg3} alt="" />
                <h4>Aftercare Service</h4>
                <p>
                  Experience uninterrupted support with our dedicated customer care team, ensuring your interiors remain flawless even after project completion.
                </p>
              </div>
            </div>
            <div className="about1-col">
              <div className="blurb">
                <img src={abimg4} alt="" />
                <h4>10-Year Warranty</h4>
                <p>
                  Benefit from high-quality materials and craftsmanship backed by a 10-year warranty for a defect-free and lasting experience.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div>
          {" "}
          <Testimonial />
        </div>


        <div className='accordian faq-layout'>
          <div className="accordian-col">
            <p className='qa'>QUESTIONS & ANSWERS</p>
            <h2 className='header2'>Let us help you find clarity</h2>
            <p className='qa-exp'>
              We’re here to answer your queries and guide you through every step of your journey with us. Explore our frequently asked questions below.
              {/* <br /><br />
          Experience the ultimate getaway at our luxurious resort,
          where every detail is designed to offer. */}
            </p>
          </div>

          <div className="accordian-col">
            {/* Place the Accordion component here */}
            <Accordion items={items} />
          </div>
        </div>
        <div className='accordian faq-layout'>
          <div className="accordian-col">
            <p className='qa'>FAQ</p>
            <h2 className='header2'>Frequently Asked Questions</h2>
            <p className='qa-exp'>
              Here are the most frequently asked questions (FAQs) clients ask during home interior design projects.
            </p>
          </div>

          <div className="accordian-col">
            <Accordion items={detailedFaqs} />
          </div>
        </div>
        <Popup showPopup={showPopup} closePopup={closePopup} />
      </div>

    </>
  )
}

